import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

import { BasePermissionsForm } from '../index'

import constants from 'constants/index'

const PermissionsForm = ({
  permissions,
  handleChange,
  activeProfile,
  isEdit,
}) => {
  const { register } = useFormContext()

  const clientProfileLists = constants.permissionsLists.clientProfileLists

  return (
    <>
      <Box mt={2} mb={3}>
        <Typography variant="h5">Permissões</Typography>
      </Box>
      <BasePermissionsForm
        title="Departamentos"
        permissionsList={clientProfileLists.departmentList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Usuários"
        permissionsList={clientProfileLists.userList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Incidentes"
        permissionsList={clientProfileLists.incidentList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Processos"
        permissionsList={clientProfileLists.dataProcessList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
        noOverFlow
      />
      <BasePermissionsForm
        title="Questionários"
        permissionsList={clientProfileLists.questionnaireList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Controle (questão)"
        permissionsList={clientProfileLists.diagnosticsList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Perfis"
        permissionsList={clientProfileLists.profileList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Relatório de Impacto à Proteção de Dados"
        permissionsList={clientProfileLists.ripdList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Minha LGPD"
        permissionsList={clientProfileLists.dashboardList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
        noOverFlow
      />
      <BasePermissionsForm
        title="Dados cadastrais da empresa"
        permissionsList={clientProfileLists.companyList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
        noOverFlow
      />
      <BasePermissionsForm
        title="Fornecedores"
        permissionsList={clientProfileLists.companySupplierList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Políticas de Privacidade"
        permissionsList={clientProfileLists.privacyPolicyList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
        noOverFlow
      />
      <BasePermissionsForm
        title="Documento"
        permissionsList={clientProfileLists.documentList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Atualizações"
        permissionsList={clientProfileLists.lastUpdatesList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Dados financeiros"
        permissionsList={clientProfileLists.financialList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Canal de denúncias"
        permissionsList={clientProfileLists.complaintList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Credenciais de SMTP"
        permissionsList={clientProfileLists.smtpCredentialList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Privacy By Design"
        permissionsList={clientProfileLists.privacyByDesignList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Gestão de Mudanças"
        permissionsList={clientProfileLists.changesManagementList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Monitoramento de PDCAs"
        permissionsList={clientProfileLists.monitoringManagementPdcaList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Monitoramento de KPIs"
        permissionsList={clientProfileLists.monitoringManagementKpiList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Monitoramento de PMCs"
        permissionsList={clientProfileLists.monitoringManagementPmcList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
      <BasePermissionsForm
        title="Monitoramento de NCs"
        permissionsList={clientProfileLists.monitoringManagementNcList}
        register={register}
        permissions={permissions}
        handleChange={handleChange}
        activeProfile={activeProfile}
        isEdit={isEdit}
      />
    </>
  )
}

PermissionsForm.propTypes = {
  register: PropTypes.func,
  permissions: PropTypes.object,
  handleChange: PropTypes.func,
  activeProfile: PropTypes.bool,
  isEdit: PropTypes.bool,
}

export default PermissionsForm
